import { inject, Injectable } from '@angular/core';
import { ModalController, ModalOptions } from '@ionic/angular';
import { from, Observable, Subject } from 'rxjs';

export type ModalProviderPayload = Record<string, unknown> | object | string | number | boolean | Date | null;

@Injectable({ providedIn: 'root' })
export class ModalService {
  private readonly modalController: ModalController = inject(ModalController);

  readonly show$: Subject<ModalOptions> = new Subject<ModalOptions>();
  readonly modalInstances: HTMLIonModalElement[] = [];

  async showModal(opts: ModalOptions): Promise<HTMLIonModalElement> {
    this.show$.next(opts);
    const modal: HTMLIonModalElement = await this.modalController.create(opts);
    await modal.present();
    this.storeModal(modal);
    return modal;
  }

  dismissAllStoredModals(): void {
    [...this.modalInstances].forEach((modal: HTMLIonModalElement, index: number) => {
      modal.dismiss();
      this.modalInstances.splice(index, 1);
    });
  }

  dismissModal$(data: ModalProviderPayload): Observable<ModalProviderPayload> {
    return from(this.modalController.dismiss(data));
  }

  isModalActive(): boolean {
    return !!this.modalInstances?.length;
  }

  private storeModal(modal: HTMLIonModalElement): void {
    this.modalInstances.push(modal);
  }
}
